import { ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons';
import { Button, IconButton, Popover } from '@radix-ui/themes';
import { t } from 'i18next';
import { IButton } from 'interfaces/i-buttons';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useState } from 'react';

export const DialogButton = (props: IButton) => {
  return (
    <Button
      className={props.className}
      size={RADIX.BUTTON.SIZE.MODAL}
      color={props.color}
      variant={props.variant ?? 'soft'}
      title={props.tooltip}
      loading={props.loading}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.icon}
      {props.label && t(props.label)}
      {props.suffixIcon}
    </Button>
  );
};

export const DialogIconButton = (props: IButton) => {
  return (
    <IconButton
      className={props.className}
      size={RADIX.BUTTON.SIZE.MODAL}
      color={props.color}
      variant={props.variant ?? 'soft'}
      title={props.tooltip}
      loading={props.loading}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.icon}
      {props.suffixIcon}
    </IconButton>
  );
};

export const DialogPopoverButton = (props: IButton) => {
  const { popoverProps } = props;

  const [isOpen, setIsOpen] = useState(false);

  const suffixIcon =
    props.suffixIcon ?? (isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />);

  return (
    <Popover.Root onOpenChange={setIsOpen}>
      <Popover.Trigger>
        <Button
          className={props.className}
          color={props.color}
          variant={props.variant ?? 'soft'}
          title={props.tooltip}
          loading={props.loading}
          disabled={props.disabled}
        >
          {props.icon}
          {props.label && t(props.label)}
          {suffixIcon}
        </Button>
      </Popover.Trigger>
      <Popover.Content
        side={popoverProps?.side}
        className={popoverProps?.className}
      >
        {popoverProps?.content}
      </Popover.Content>
    </Popover.Root>
  );
};
